import { render, staticRenderFns } from "./CustomerDataForm.vue?vue&type=template&id=74ceb856&"
import script from "./CustomerDataForm.vue?vue&type=script&lang=js&"
export * from "./CustomerDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports